const AppConfig = {
  key: {
    LoggedIn: 'loggedInMemberLottokey',
    RefreshTokenKey: 'appRefreshMemberTokenKey',
    TokenKey: 'appMemberTokenKey'
  }
}

export default AppConfig;
